import {
  accesscontroller1,
  accesscontroller2,
  accesscontroller3,
  accesscontroller4,
  accesscontrollerOutlook,
  accesscontrollerThumb,
  accessAuto1,
  accessAuto2,
  accessAuto3,
  accessAuto4,
  accessAutoOutlook,
  accessAutoThumb,
  accessKey1,
  accessKey2,
  accessKey3,
  accessKey4,
  accessKeyOutlook,
  accessKeyThumb,
  accessKeyM1,
  accessPro1,
  accessPro2,
  accessPro3,
  accessPro4,
  accessProOutlook,
  accessProThumb,
  apart1,
  apart2,
  apart3,
  apart4,
  apartThumb,
  deadbolt1,
  deadbolt2,
  deadbolt3,
  deadbolt4,
  deadboltThumb,
  deadboltM1,
  emlock1,
  emlock2,
  emlock3,
  emlock4,
  emlockThumb,
  emlockM1,
  accessLite2,
  accessLite3,
  accessLite4,
  accessLite5,
  accessLite6,
  accessLiteThumb,
} from '@assets/images/main/access/product';

import {
  assetTag1,
  assetTag2,
  assetTag3,
  assetTag4,
  assetTagOutlook,
  orbroTag1,
  orbroTag2,
  orbroTag3,
  orbroTag4,
  orbroTagOutlook,
} from '@assets/images/main/beacon/product';
import {
  carTracking1,
  carTracking2,
  carTracking3,
  carTracking4,
  carTrackingKey1,
  carTrackingKey2,
  carTrackingKey3,
  carTrackingKey4,
  carTrackingKey5,
  edgeAi1,
  enterpriseKit1,
  enterpriseKit2,
  enterpriseKit3,
  enterpriseKitTopology,
  ipCam1,
  ipCam2,
  ipCam3,
  ipCam4,
  ipCamKey1,
  ipCamKey2,
  ipCamKey3,
  ipThumb,
  l2SwitchOutlook,
  peopleTracking1,
  peopleTracking2,
  peopleTracking3,
  peopleTracking4,
  peopleTrackingKey1,
  peopleTrackingKey2,
  peopleTrackingKey3,
  peopleTrackingKey4,
  ptzCam1,
  ptzCam2,
  ptzCam3,
  ptzCam4,
  ptzCamKey1,
  ptzCamKey2,
  ptzCamKey3,
  ptzThumb,
  starterKit1,
  starterKit2,
  starterKit3,
  starterKit4,
  starterKit5,
  starterKit6,
  starterKit7,
  starterKit8,
  starterKit9,
  starterKitOutlook,
  starterKitTopology,
} from '@assets/images/main/camera';
import {
  cobot1,
  cobot2,
  cobot3,
  deliverPackage,
  deliverRobot1,
  deliverRobot2,
  disinfection1,
  disinfection2,
  loadingKiosk1,
  loadingKiosk2,
} from '@assets/images/main/integration';
import {
  bell1,
  bell2,
  bell3,
  bell4,
  bellOutlook,
  esl1,
  esl2,
  esl3,
  esl4,
  eslOutlook,
  idCard1,
  idCard2,
  idCard3,
  idCard4,
  idCard5,
  idCard6,
  idCard7,
  idCardOutlook,
  mCradle1,
  mCradle2,
  mCradle3,
  mCradle4,
  mCradle5,
  mCradle6,
  mCradle7,
  mCradleOutlook,
  mCradleThumb,
  mTag1,
  mTag2,
  mTag2_1,
  mTag2_2,
  mTag2_3,
  mTag2_4,
  mTag2_Outlook,
  mTag2_Thumb,
  mTag2_key1,
  mTag2_key2,
  mTag2_key3,
  mTag3,
  mTag4,
  mTagOutlook,
  mTagThumb,
  switch1,
  switch2,
  switch3,
  switch4,
  switchOutlook,
} from '@assets/images/main/iot/product';
import { osEdgeAiBottom, osL2SwitchBottom, osServer1, osServer2, osServer3 } from '@assets/images/main/os/product';
import {
  vehicleTrackingKit1,
  vehicleTrackingKit2,
  vehicleTrackingKit3,
  vehicleTrackingKitThumb,
  yardTrackingKit1,
  yardTrackingKit2,
  yardTrackingKit3,
  yardTrackingKitThumb,
} from '@assets/images/main/outdoor';
import {
  accessLiteOutlook,
  aoaOutlook,
  coinTagOutlook,
  edgeRtlsOutlook,
  gpsOutlook,
  l2switchOutlook,
  orbroAoaTagOutlook,
  plutoconProOutlook,
  slimtagOutlook,
  stickerTagOutlook,
  twintrackerBleOutlook,
  uwbTagOutlook,
} from '@assets/images/main/outlook';
import {
  aoaEnterpriseKit,
  aoaEnterpriseKitThumb,
  aoaStarterKit,
  aoaStarterKitThumb,
  assetTagBle1,
  assetTagBle2,
  assetTagBle3,
  assetTagBleOutlook,
  assetTracking1,
  assetTracking2,
  assetTracking3,
  assetTracking4,
  bleEnterpriseKit,
  bleStarterKit,
  bleStarterKit2,
  comfortKit1,
  comfortKit2,
  comfortKitThumb,
  edgeRtls1,
  serverPc,
  tagUwb1,
  tagUwb2,
  tagUwbOutlook,
  twinTracker1,
  twinTracker2,
  twinTracker3,
  twinTracker4,
  twinTracker5,
  twinTracker6,
  twintracker7,
  twinTrackerAoa1,
  twinTrackerAoa2,
  twinTrackerAoa3,
  twinTrackerAoaThumb,
  twinTrackerBracket,
  twinTrackerOutlook,
  uwbEnterpriseKit,
  uwbEnterpriseKitThumb,
  uwbStarterKit,
  uwbStarterKitThumb,
  uwbTag1,
  uwbTag2,
  workerTracking1,
} from '@assets/images/main/rtls/product';
import {
  airQuality1,
  airQuality2,
  airQuality3,
  airQuality4,
  coMeasure1,
  coMeasure2,
  coMeasure3,
  coMeasure4,
  loraGateway1,
  loraGateway2,
  loraGateway3,
  loraGateway4,
  loraSensor1,
  loraSensor2,
  loraSensor3,
  loraSensor4,
} from '@assets/images/main/sensor';
import { eslThumbnail, safetyBellThumbnail, switchThumbnail, twinTrackerThumbnail } from '@assets/images/main/thumbnail';
import {
  aoaEnterpriseTopology,
  aoaStarterTopology,
  bleEnterpriseTopology,
  bleStarterTopology,
  osAiTopology,
  osRtlsTopology,
  osServerTopology,
  osSwitchTopology,
  twintrackerUwbTopology,
  uwbEnterpriseTopology,
  uwbStarterTopology,
} from '@assets/images/main/topology';
import OsSwitch from '@pages/Main/OS/Products/OsSwitch';

export default {
  document: '문서',
  product: {
    accesscontroller: {
      thumbnail: accesscontrollerThumb,

      mini1: accesscontroller1,
      mini2: accesscontroller2,
      mini3: accesscontroller3,
      mini4: accesscontroller4,

      key1: accesscontroller1,
      key2: accesscontroller2,
      key3: accesscontroller3,

      outlook: [
        {
          title: '',
          desc: '',
          img: accesscontrollerOutlook,
        },
      ],

      redDot: 0,
    },

    accessauto: {
      thumbnail: accessAutoThumb,

      mini1: accessAuto1,
      mini2: accessAuto2,
      mini3: accessAuto3,
      mini4: accessAuto4,

      key1: accessAuto1,
      key2: accessAuto3,
      key3: accessAuto2,

      outlook: [
        {
          title: '',
          desc: '',
          img: accessAutoOutlook,
        },
      ],

      redDot: 1,
      download: [
        {
          name: 'Access Auto - Datasheet v1.0',
          date: '2025-06-02',
          data: 'Access Auto',
        },
      ],
    },

    apart: {
      thumbnail: apartThumb,

      mini1: apart1,
      mini2: apart2,
      mini3: apart3,
      mini4: apart4,

      key1: apart2,
      key2: apart4,
      key3: apart3,
      key4: accessAuto1,

      outlook: [
        {
          title: '',
          desc: '',
          img: accessAutoOutlook,
        },
      ],

      redDot: 0,
    },

    cloud: {
      thumbnail: accessAutoThumb,

      mini1: accessAuto1,
      mini2: accessAuto2,
      mini3: accessAuto3,
      mini4: accessAuto4,

      key1: accessAuto1,
      key2: accessAuto3,
      key3: accessAuto2,

      outlook: [
        {
          title: '',
          desc: '',
          img: accessAutoOutlook,
        },
      ],

      // download: [
      //   {
      //     name: 'Access Auto - Datasheet v1.0',
      //     date: '2023-11-20',
      //     data: 'Access Auto',
      //   },
      // ],
      redDot: 1,
    },

    accesspro: {
      thumbnail: accessProThumb,

      mini1: accessPro1,
      mini2: accessPro2,
      mini3: accessPro3,
      mini4: accessPro4,

      key1: accessPro1,
      key2: accessPro2,
      key3: accessPro4,

      outlook: [
        {
          title: '',
          desc: '',
          img: accessProOutlook,
        },
      ],
      download: [
        {
          name: 'Access Pro - Datasheet v1.0',
          date: '2025-06-02',
          data: 'Access Pro',
        },
      ],

      redDot: 0,
    },

    accessLite: {
      thumbnail: accessLiteThumb,

      mini1: accessLiteThumb,
      mini2: accessLite2,
      mini3: accessLite4,
      mini4: accessLite5,

      key1: accessLite6,
      key2: accessLite2,
      key3: accessLite3,

      design: [
        {
          title: '',
          desc: '',
          img1: accessLiteThumb,
          img2: accessLite2,
          img3: accessLite3,
        },
        {
          title: '',
          desc: '',
          img1: '',
          img2: accessLite4,
          img3: accessLite5,
        },
      ],
      outlook: [
        {
          title: 'Access Lite',
          desc: 'OAC-LGBT0001',
          img: accessLiteOutlook,
        },
      ],

      download: [
        {
          name: 'Access Lite - Datasheet v1.0',
          date: '2025-06-02',
          data: 'Access Lite',
        },
      ],

      redDot: 0,
    },

    accesskey: {
      thumbnail: accessKeyThumb,

      mini1: accessKeyM1,
      mini2: accessKey2,
      mini3: accessKey3,
      mini4: accessKey4,

      key1: accessKeyM1,
      key2: accessKey2,
      key3: accessKey3,

      outlook: [
        {
          title: '',
          desc: '',
          img: accessKeyOutlook,
        },
      ],

      download: [
        {
          name: 'Access Key - Datasheet v1.0',
          date: '2025-06-02',
          data: 'Access Key',
        },
      ],

      redDot: 0,
    },

    emlock: {
      thumbnail: emlockThumb,

      mini1: emlockM1,
      mini2: emlock2,
      mini3: emlock3,
      mini4: emlock4,

      key1: emlockM1,
      key2: emlock2,
      key3: emlock3,

      outlook: '',

      redDot: 0,
    },

    deadbolt: {
      thumbnail: deadboltThumb,

      mini1: deadboltM1,
      mini2: deadbolt2,
      mini3: deadbolt3,
      mini4: deadbolt4,

      key1: deadboltM1,
      key2: deadbolt2,
      key3: deadbolt3,

      outlook: '',

      redDot: 0,
    },

    autoDoorSensor: {
      thumbnail: accessAutoThumb,

      mini1: accessAuto1,
      mini2: accessAuto2,
      mini3: accessAuto3,
      mini4: accessAuto4,

      key1: accessAuto1,
      key2: accessAuto3,
      key3: accessAuto2,

      outlook: [
        {
          title: '',
          desc: '',
          img: accessAutoOutlook,
        },
      ],

      redDot: 0,
    },

    twinTracker: {
      design: [
        {
          title: '',
          desc: '',
          img1: twinTracker6,
          img2: twinTracker3,
          img3: twintracker7,
        },
      ],

      out: [
        {
          title: '',
          desc: '',
          img: twinTrackerOutlook,
        },
      ],

      thumbnail: twinTracker6,

      mini1: twinTracker6,
      mini2: twinTracker3,
      mini3: twintracker7,
      mini4: twinTracker5,

      key1: twinTracker6,
      key2: twinTracker3,
      key3: twintracker7,
      // outlook: twinTrackerOutlook,

      outlook: [
        {
          title: 'TwinTracker BLE',
          desc: 'OTR-TTBT0001',
          img: assetTagBleOutlook,
        },
      ],
      title: 'TwinTracker',
      desc: '복잡한 설치 과정 없이 PoE(Power over Ethernet) 연결만으로 태그 단말기의 무선 신호를 추적합니다.',

      download: [
        {
          name: 'TwinTracker BLE - Datasheet v1.0',
          date: '2025-06-02',
          data: 'TwinTracker BLE',
        },
        {
          name: 'Coin Tag - Datasheet v1.0',
          date: '2025-06-02',
          data: 'Coin Tag',
        },
        {
          name: 'ORBRO Tag - Datasheet v1.0',
          date: '2025-06-02',
          data: 'ORBRO tag',
        },
        {
          name: 'Plutocon Pro - Datasheet v1.0',
          date: '2025-06-02',
          data: 'Plutocon Pro',
        },
        {
          name: 'Slim Tag - Datasheet v1.0',
          date: '2025-06-02',
          data: 'Slim Tag',
        },
        {
          name: 'Sticker Tag - Datasheet v1.0',
          date: '2025-06-02',
          data: 'Sticker Tag',
        },
      ],

      redDot: 0,
    },

    twinTrackerPro: {
      design: [
        {
          title: '',
          desc: '',
          img1: twinTracker1,
          img2: twinTracker2,
          img3: twinTracker3,
        },
      ],

      out: [
        {
          title: '',
          desc: '',
          img: twinTrackerOutlook,
        },
      ],

      thumbnail: twinTrackerThumbnail,

      mini1: twinTrackerThumbnail,
      mini2: twinTracker3,
      mini3: twinTracker4,
      mini4: twinTracker5,

      key1: assetTracking1,
      key2: assetTracking2,
      key3: assetTracking3,

      outlook: [
        {
          title: '',
          desc: '',
          img: twinTrackerOutlook,
        },
      ],
      download: [
        {
          name: 'Twin Tracker Pro - Datasheet v1.0',
          date: '2023-11-20',
          data: 'Twin Tracker Pro',
        },
      ],

      title: 'TwinTracker',
      desc: '복잡한 설치 과정 없이 PoE(Power over Ethernet) 연결만으로 태그 단말기의 무선 신호를 추적합니다.',

      redDot: 0,
    },

    twinTrackerAoa: {
      design: [
        {
          title: '',
          desc: '',
          img1: twinTrackerAoa3,
          img2: twinTrackerAoa1,
          img3: twinTrackerAoa2,
        },
      ],

      out: [
        {
          title: '',
          desc: '',
          img: aoaOutlook,
        },
      ],

      thumbnail: twinTrackerAoaThumb,

      mini1: twinTrackerAoa3,
      mini2: twinTrackerAoa1,
      mini3: twinTrackerAoa2,
      mini4: twinTrackerBracket,

      key1: twinTrackerAoa3,
      key2: twinTrackerAoa1,
      key3: twinTrackerAoa2,
      // outlook: twinTrackerOutlook,

      outlook: [
        {
          title: 'TwinTracker AoA',
          desc: 'OTR-TTAO0001',
          img: aoaOutlook,
        },
      ],
      title: 'TwinTracker',
      desc: '복잡한 설치 과정 없이 PoE(Power over Ethernet) 연결만으로 태그 단말기의 무선 신호를 추적합니다.',

      download: [
        {
          name: 'TwinTracker AoA - Datasheet v1.0',
          date: '2025-06-02',
          data: 'TwinTracker AoA',
        },
      ],

      redDot: 0,
    },

    aoaStarterKit: {
      design: [
        {
          title: '',
          desc: '',
          img1: aoaStarterKit,
          img2: edgeRtls1,
          img3: starterKit3,
        },
        {
          title: '',
          desc: '',
          img1: '',
          img2: starterKit4,
          img3: starterKit5,
        },
        {
          title: '',
          desc: '',
          img1: '',
          img2: twinTrackerAoa3,
          img3: twinTrackerAoa1,
        },
      ],

      out: [
        {
          title: 'TwinTracker',
          desc: '복잡한 설치 과정 없이 PoE(Power over Ethernet) 연결만으로 자산 태그 단말기의 무선 신호를 추적합니다.',
          img: twinTrackerOutlook,
        },
        {
          title: 'Asset Tag(BLE)',
          desc: '손쉬운 부착으로 작업자의 위치를 추적 할 수 있습니다.',
          img: assetTagBleOutlook,
        },
      ],

      thumbnail: aoaStarterKitThumb,

      mini1: aoaStarterKit,
      mini2: edgeRtls1,
      mini3: starterKit4,
      mini4: twinTrackerAoa3,

      key1: aoaStarterKit,
      key2: edgeRtls1,
      key3: starterKit3,

      topology: aoaStarterTopology,

      outlook: [
        {
          title: 'ORBRO Edge RTLS',
          desc: 'ONT-ERWF0001',
          img: edgeRtlsOutlook,
        },
        {
          title: 'L2 Switch',
          desc: 'ONT-LRBT5001',
          img: l2switchOutlook,
        },
        {
          title: 'TwinTracker AoA',
          desc: 'OTR-TTAO0001',
          img: aoaOutlook,
        },
        {
          title: 'ORBRO AoA Tag',
          desc: 'OAS-OTAO1991',
          img: orbroAoaTagOutlook,
        },
      ],
      download: [
        {
          name: 'ORBRO Edge RTLS - Datasheet v1.0',
          date: '2025-06-02',
          data: 'ORBRO Edge RTLS',
        },
        {
          name: 'L2 Switch - Datasheet v1.0',
          date: '2025-06-02',
          data: 'L2 Switch',
        },
        {
          name: 'TwinTracker AoA - Datasheet v1.0',
          date: '2025-06-02',
          data: 'TwinTracker AoA',
        },
      ],

      title: 'TwinTracker',
      desc: '복잡한 설치 과정 없이 PoE(Power over Ethernet) 연결만으로 태그 단말기의 무선 신호를 추적합니다.',

      redDot: 0,
    },

    aoaEnterpriseKit: {
      design: [
        {
          title: '',
          desc: '',
          img1: aoaEnterpriseKit,
          img2: '',
          img3: '',
          img4: enterpriseKit2,
        },
        {
          title: '',
          desc: '',
          img1: '',
          img2: edgeRtls1,
          img3: starterKit3,
        },
        {
          title: '',
          desc: '',
          img1: '',
          img2: starterKit4,
          img3: starterKit5,
        },
        {
          title: '',
          desc: '',
          img1: '',
          img2: twinTrackerAoa3,
          img3: twinTrackerAoa1,
        },
      ],

      out: [
        {
          title: 'TwinTracker',
          desc: '복잡한 설치 과정 없이 PoE(Power over Ethernet) 연결만으로 자산 태그 단말기의 무선 신호를 추적합니다.',
          img: twinTrackerOutlook,
        },
        {
          title: 'Asset Tag(BLE)',
          desc: '손쉬운 부착으로 작업자의 위치를 추적 할 수 있습니다.',
          img: assetTagBleOutlook,
        },
      ],

      thumbnail: aoaEnterpriseKitThumb,

      mini1: aoaEnterpriseKit,
      mini2: edgeRtls1,
      mini3: starterKit4,
      mini4: twinTrackerAoa3,

      key1: assetTracking1,
      key2: assetTracking2,
      key3: assetTracking3,

      topology: aoaEnterpriseTopology,

      outlook: [
        {
          title: 'ORBRO Edge RTLS',
          desc: 'ONT-ERWF0001',
          img: edgeRtlsOutlook,
        },
        {
          title: 'L2 Switch',
          desc: 'ONT-LRBT5001',
          img: l2switchOutlook,
        },
        {
          title: 'TwinTracker AoA',
          desc: 'OTR-TTAO0001',
          img: aoaOutlook,
        },
        {
          title: 'ORBRO AoA Tag',
          desc: 'OAS-OTAO1991',
          img: orbroAoaTagOutlook,
        },
      ],
      download: [
        {
          name: 'ORBRO Server - Datasheet v1.0',
          date: '2025-06-02',
          data: 'ORBRO Server',
        },
        {
          name: 'ORBRO Edge RTLS - Datasheet v1.0',
          date: '2025-06-02',
          data: 'ORBRO Edge RTLS',
        },
        {
          name: 'L2 Switch - Datasheet v1.0',
          date: '2025-06-02',
          data: 'L2 Switch',
        },
        {
          name: 'TwinTracker AoA - Datasheet v1.0',
          date: '2025-06-02',
          data: 'TwinTracker AoA',
        },
      ],

      title: 'TwinTracker',
      desc: '복잡한 설치 과정 없이 PoE(Power over Ethernet) 연결만으로 태그 단말기의 무선 신호를 추적합니다.',

      redDot: 0,
    },

    twinTrackerUwb: {
      design: [
        {
          title: '',
          desc: '',
          img1: twinTracker6,
          img2: twinTracker3,
          img3: twintracker7,
        },
      ],

      out: [
        {
          title: '',
          desc: '',
          img: twinTrackerOutlook,
        },
      ],

      thumbnail: twinTracker6,

      mini1: twinTracker6,
      mini2: twinTracker3,
      mini3: twintracker7,
      mini4: twinTracker5,

      key1: twinTracker6,
      key2: twinTracker3,
      key3: twintracker7,
      // outlook: twinTrackerOutlook,
      topology: twintrackerUwbTopology,

      outlook: [
        {
          title: 'TwinTracker UWB',
          desc: 'OTR-TTUW0001',
          img: twintrackerBleOutlook,
        },
      ],
      title: 'TwinTracker',
      desc: '복잡한 설치 과정 없이 PoE(Power over Ethernet) 연결만으로 태그 단말기의 무선 신호를 추적합니다.',

      download: [
        {
          name: 'TwinTracker UWB - Datasheet v1.0',
          date: '2025-06-02',
          data: 'TwinTracker UWB',
        },
      ],

      redDot: 0,
    },

    uwbStarterKit: {
      design: [
        {
          title: '',
          desc: '',
          img1: uwbStarterKit,
          img2: edgeRtls1,
          img3: starterKit3,
        },
        {
          title: '',
          desc: '',
          img1: '',
          img2: starterKit4,
          img3: starterKit5,
        },
        {
          title: '',
          desc: '',
          img1: '',
          img2: twinTracker6,
          img3: twinTracker3,
        },
      ],

      out: [
        {
          title: 'TwinTracker',
          desc: '복잡한 설치 과정 없이 PoE(Power over Ethernet) 연결만으로 자산 태그 단말기의 무선 신호를 추적합니다.',
          img: twinTrackerOutlook,
        },
        {
          title: 'Asset Tag(BLE)',
          desc: '손쉬운 부착으로 작업자의 위치를 추적 할 수 있습니다.',
          img: assetTagBleOutlook,
        },
      ],

      thumbnail: uwbStarterKitThumb,

      mini1: uwbStarterKit,
      mini2: edgeRtls1,
      mini3: starterKit4,
      mini4: twinTracker6,

      key1: uwbStarterKit,
      key2: edgeRtls1,
      key3: starterKit3,

      topology: uwbStarterTopology,

      outlook: [
        {
          title: 'ORBRO Edge RTLS',
          desc: 'ONT-ERWF0001',
          img: edgeRtlsOutlook,
        },
        {
          title: 'L2 Switch',
          desc: 'ONT-LRBT5001',
          img: l2switchOutlook,
        },
        {
          title: 'TwinTracker UWB',
          desc: 'OTR-TTUW0001',
          img: twintrackerBleOutlook,
        },
        {
          title: 'UWB Tag',
          desc: 'OTR-UTUW2062',
          img: uwbTagOutlook,
        },
      ],
      download: [
        {
          name: 'ORBRO Edge RTLS - Datasheet v1.0',
          date: '2025-06-02',
          data: 'ORBRO Edge RTLS',
        },
        {
          name: 'L2 Switch - Datasheet v1.0',
          date: '2025-06-02',
          data: 'L2 Switch',
        },
        {
          name: 'TwinTracker UWB - Datasheet v1.0',
          date: '2025-06-02',
          data: 'TwinTracker UWB',
        },
        {
          name: 'UWB Tag - Datasheet v1.0',
          date: '2025-06-02',
          data: 'UWB Tag',
        },
      ],

      title: 'TwinTracker',
      desc: '복잡한 설치 과정 없이 PoE(Power over Ethernet) 연결만으로 태그 단말기의 무선 신호를 추적합니다.',

      redDot: 0,
    },

    uwbEnterpriseKit: {
      design: [
        {
          title: '',
          desc: '',
          img1: uwbEnterpriseKit,
          img2: '',
          img3: '',
          img4: enterpriseKit2,
        },
        {
          title: '',
          desc: '',
          img1: '',
          img2: edgeRtls1,
          img3: starterKit3,
        },
        {
          title: '',
          desc: '',
          img1: '',
          img2: starterKit4,
          img3: starterKit5,
        },
        {
          title: '',
          desc: '',
          img1: '',
          img2: twinTracker6,
          img3: twinTracker3,
        },
      ],

      out: [
        {
          title: 'TwinTracker',
          desc: '복잡한 설치 과정 없이 PoE(Power over Ethernet) 연결만으로 자산 태그 단말기의 무선 신호를 추적합니다.',
          img: twinTrackerOutlook,
        },
        {
          title: 'Asset Tag(BLE)',
          desc: '손쉬운 부착으로 작업자의 위치를 추적 할 수 있습니다.',
          img: assetTagBleOutlook,
        },
      ],

      thumbnail: uwbEnterpriseKitThumb,

      mini1: uwbEnterpriseKit,
      mini2: edgeRtls1,
      mini3: starterKit4,
      mini4: twinTracker6,

      key1: assetTracking1,
      key2: assetTracking2,
      key3: assetTracking3,

      topology: uwbEnterpriseTopology,

      outlook: [
        {
          title: 'ORBRO Edge RTLS',
          desc: 'ONT-ERWF0001',
          img: edgeRtlsOutlook,
        },
        {
          title: 'L2 Switch',
          desc: 'ONT-LRBT5001',
          img: l2switchOutlook,
        },
        {
          title: 'TwinTracker UWB',
          desc: 'OTR-TTUW0001',
          img: twintrackerBleOutlook,
        },
        {
          title: 'UWB Tag',
          desc: 'OTR-UTUW2062',
          img: uwbTagOutlook,
        },
      ],
      download: [
        {
          name: 'ORBRO Server - Datasheet v1.0',
          date: '2025-06-02',
          data: 'ORBRO Server',
        },
        {
          name: 'ORBRO Edge RTLS - Datasheet v1.0',
          date: '2025-06-02',
          data: 'ORBRO Edge RTLS',
        },
        {
          name: 'L2 Switch - Datasheet v1.0',
          date: '2025-06-02',
          data: 'L2 Switch',
        },
        {
          name: 'TwinTracker UWB - Datasheet v1.0',
          date: '2025-06-02',
          data: 'TwinTracker UWB',
        },
        {
          name: 'UWB Tag - Datasheet v1.0',
          date: '2025-06-02',
          data: 'UWB Tag',
        },
      ],

      title: 'TwinTracker',
      desc: '복잡한 설치 과정 없이 PoE(Power over Ethernet) 연결만으로 태그 단말기의 무선 신호를 추적합니다.',

      redDot: 0,
    },

    bleStarterKit: {
      design: [
        {
          title: '',
          desc: '',
          img1: bleStarterKit2,
          img2: edgeRtls1,
          img3: starterKit3,
        },
        {
          title: '',
          desc: '',
          img1: '',
          img2: starterKit4,
          img3: starterKit5,
        },
        {
          title: '',
          desc: '',
          img1: '',
          img2: twinTracker6,
          img3: twinTracker3,
        },
      ],

      out: [
        {
          title: 'TwinTracker',
          desc: '복잡한 설치 과정 없이 PoE(Power over Ethernet) 연결만으로 자산 태그 단말기의 무선 신호를 추적합니다.',
          img: twinTrackerOutlook,
        },
        {
          title: 'Asset Tag(BLE)',
          desc: '손쉬운 부착으로 작업자의 위치를 추적 할 수 있습니다.',
          img: assetTagBleOutlook,
        },
      ],

      thumbnail: bleStarterKit2,

      mini1: bleStarterKit2,
      mini2: edgeRtls1,
      mini3: starterKit4,
      mini4: twinTracker6,

      key1: bleStarterKit2,
      key2: edgeRtls1,
      key3: starterKit3,

      topology: bleStarterTopology,

      outlook: [
        {
          title: 'ORBRO Edge RTLS',
          desc: 'ONT-ERWF0001',
          img: edgeRtlsOutlook,
        },
        {
          title: 'L2 Switch',
          desc: 'ONT-LRBT5001',
          img: l2switchOutlook,
        },
        {
          title: 'TwinTracker BLE',
          desc: 'OTR-TTBT0001',
          img: twintrackerBleOutlook,
        },
        {
          title: 'ORBRO Tag',
          desc: 'OAS-OTBT1991',
          img: orbroTagOutlook,
        },
        {
          title: 'Plutocon Pro',
          desc: 'KB-BK02',
          img: plutoconProOutlook,
        },
        {
          title: 'Coin Tag',
          desc: 'CD16BTR01X',
          img: coinTagOutlook,
        },
        {
          title: 'Slim Tag',
          desc: 'CD16BTS01X',
          img: slimtagOutlook,
        },
        {
          title: 'Sticker Tag',
          desc: 'CD16BTS01X',
          img: stickerTagOutlook,
        },
      ],
      download: [
        {
          name: 'ORBRO Edge RTLS - Datasheet v1.0',
          date: '2025-06-02',
          data: 'ORBRO Edge RTLS',
        },
        {
          name: 'L2 Switch - Datasheet v1.0',
          date: '2025-06-02',
          data: 'L2 Switch',
        },
        {
          name: 'TwinTracker BLE - Datasheet v1.0',
          date: '2025-06-02',
          data: 'TwinTracker BLE',
        },
        {
          name: 'Coin Tag - Datasheet v1.0',
          date: '2025-06-02',
          data: 'Coin Tag',
        },
        {
          name: 'ORBRO Tag - Datasheet v1.0',
          date: '2025-06-02',
          data: 'ORBRO tag',
        },
        {
          name: 'Plutocon Pro - Datasheet v1.0',
          date: '2025-06-02',
          data: 'Plutocon Pro',
        },
        {
          name: 'Slim Tag - Datasheet v1.0',
          date: '2025-06-02',
          data: 'Slim Tag',
        },
        {
          name: 'Sticker Tag - Datasheet v1.0',
          date: '2025-06-02',
          data: 'Sticker Tag',
        },
      ],

      title: 'TwinTracker',
      desc: '복잡한 설치 과정 없이 PoE(Power over Ethernet) 연결만으로 태그 단말기의 무선 신호를 추적합니다.',

      redDot: 0,
    },

    bleEnterpriseKit: {
      design: [
        {
          title: '',
          desc: '',
          img1: bleEnterpriseKit,
          img2: '',
          img3: '',
          img4: enterpriseKit2,
        },
        {
          title: '',
          desc: '',
          img1: '',
          img2: edgeRtls1,
          img3: starterKit3,
        },
        {
          title: '',
          desc: '',
          img1: '',
          img2: starterKit4,
          img3: starterKit5,
        },
        {
          title: '',
          desc: '',
          img1: '',
          img2: twinTracker6,
          img3: twinTracker3,
        },
      ],

      out: [
        {
          title: 'TwinTracker',
          desc: '복잡한 설치 과정 없이 PoE(Power over Ethernet) 연결만으로 자산 태그 단말기의 무선 신호를 추적합니다.',
          img: twinTrackerOutlook,
        },
        {
          title: 'Asset Tag(BLE)',
          desc: '손쉬운 부착으로 작업자의 위치를 추적 할 수 있습니다.',
          img: assetTagBleOutlook,
        },
      ],

      thumbnail: bleEnterpriseKit,

      mini1: bleEnterpriseKit,
      mini2: edgeRtls1,
      mini3: starterKit4,
      mini4: twinTracker6,

      key1: assetTracking1,
      key2: assetTracking2,
      key3: assetTracking3,

      topology: bleEnterpriseTopology,

      outlook: [
        {
          title: 'ORBRO Edge RTLS',
          desc: 'ONT-ERWF0001',
          img: edgeRtlsOutlook,
        },
        {
          title: 'L2 Switch',
          desc: 'ONT-LRBT5001',
          img: l2switchOutlook,
        },
        {
          title: 'TwinTracker BLE',
          desc: 'OTR-TTBT0001',
          img: twintrackerBleOutlook,
        },
        {
          title: 'ORBRO Tag',
          desc: 'OAS-OTBT1991',
          img: orbroTagOutlook,
        },
        {
          title: 'Plutocon Pro',
          desc: 'KB-BK02',
          img: plutoconProOutlook,
        },
        {
          title: 'Coin Tag',
          desc: 'CD16BTR01X',
          img: coinTagOutlook,
        },
        {
          title: 'Slim Tag',
          desc: 'CD16BTS01X',
          img: slimtagOutlook,
        },
        {
          title: 'Sticker Tag',
          desc: 'CD16BTS01X',
          img: stickerTagOutlook,
        },
      ],
      download: [
        {
          name: 'ORBRO Server - Datasheet v1.0',
          date: '2025-06-02',
          data: 'ORBRO Server',
        },
        {
          name: 'ORBRO Edge RTLS - Datasheet v1.0',
          date: '2025-06-02',
          data: 'ORBRO Edge RTLS',
        },
        {
          name: 'L2 Switch - Datasheet v1.0',
          date: '2025-06-02',
          data: 'L2 Switch',
        },
        {
          name: 'TwinTracker BLE - Datasheet v1.0',
          date: '2025-06-02',
          data: 'TwinTracker BLE',
        },
        {
          name: 'Coin Tag - Datasheet v1.0',
          date: '2025-06-02',
          data: 'Coin Tag',
        },
        {
          name: 'ORBRO Tag - Datasheet v1.0',
          date: '2025-06-02',
          data: 'ORBRO tag',
        },
        {
          name: 'Plutocon Pro - Datasheet v1.0',
          date: '2025-06-02',
          data: 'Plutocon Pro',
        },
        {
          name: 'Slim Tag - Datasheet v1.0',
          date: '2025-06-02',
          data: 'Slim Tag',
        },
        {
          name: 'Sticker Tag - Datasheet v1.0',
          date: '2025-06-02',
          data: 'Sticker Tag',
        },
      ],

      title: 'TwinTracker',
      desc: '복잡한 설치 과정 없이 PoE(Power over Ethernet) 연결만으로 태그 단말기의 무선 신호를 추적합니다.',

      redDot: 0,
    },

    comfortKit: {
      design: [
        {
          title: '',
          desc: '',
          img1: comfortKit1,
          img2: uwbTag1,
          img3: uwbTag2,
        },
      ],

      out: [
        {
          title: '',
          desc: '',
          img: twinTrackerOutlook,
        },
      ],

      thumbnail: comfortKitThumb,

      mini1: comfortKitThumb,
      mini2: comfortKit2,
      mini3: uwbTag1,
      mini4: uwbTag2,

      key1: twinTracker6,
      key2: twinTracker3,
      key3: twintracker7,

      outlook: [
        {
          title: 'UWB Tag',
          desc: 'OTR-UTUW2062',
          img: uwbTagOutlook,
        },
      ],
      title: 'TwinTracker',
      desc: '복잡한 설치 과정 없이 PoE(Power over Ethernet) 연결만으로 태그 단말기의 무선 신호를 추적합니다.',

      download: [
        {
          name: 'UWB Tag - Datasheet v1.0',
          date: '2025-06-02',
          data: 'UWB Tag',
        },
      ],

      redDot: 0,
    },

    gpsDevice: {
      design: [
        {
          title: '',
          desc: '',
          img1: vehicleTrackingKit1,
          img2: '',
          img3: '',
        },
        {
          title: '',
          desc: '',
          img1: enterpriseKit2,
          img2: vehicleTrackingKit2,
          img3: vehicleTrackingKit3,
        },
      ],

      out: [
        {
          title: '',
          desc: '',
          img: twinTrackerOutlook,
        },
      ],

      thumbnail: vehicleTrackingKitThumb,

      mini1: vehicleTrackingKit1,
      mini2: enterpriseKit2,
      mini3: vehicleTrackingKit2,
      mini4: vehicleTrackingKit3,

      key1: twinTracker6,
      key2: twinTracker3,
      key3: twintracker7,

      outlook: [
        {
          title: 'GPS Device',
          desc: 'OTR-GD4G2121',
          img: gpsOutlook,
        },
      ],
      title: 'TwinTracker',
      desc: '복잡한 설치 과정 없이 PoE(Power over Ethernet) 연결만으로 태그 단말기의 무선 신호를 추적합니다.',

      download: [
        {
          name: 'Vehicle Tracking Kit - Datasheet v1.0',
          date: '2025-06-02',
          data: 'Vehicle Tracking Kit',
        },
      ],

      redDot: 0,
    },

    gpsTag: {
      design: [
        {
          title: '',
          desc: '',
          img1: yardTrackingKitThumb,
          img2: '',
          img3: '',
        },
        {
          title: '',
          desc: '',
          img1: enterpriseKit2,
          img2: loraGateway1,
          img3: loraGateway2,
        },
        {
          title: '',
          desc: '',
          img1: '',
          img2: yardTrackingKit2,
          img3: yardTrackingKit3,
        },
      ],

      out: [
        {
          title: '',
          desc: '',
          img: twinTrackerOutlook,
        },
      ],

      thumbnail: yardTrackingKitThumb,

      mini1: yardTrackingKitThumb,
      mini2: enterpriseKit2,
      mini3: loraGateway1,
      mini4: yardTrackingKit2,

      key1: twinTracker6,
      key2: twinTracker3,
      key3: twintracker7,

      title: 'TwinTracker',
      desc: '복잡한 설치 과정 없이 PoE(Power over Ethernet) 연결만으로 태그 단말기의 무선 신호를 추적합니다.',

      download: [
        {
          name: 'Yard Tracking Kit - Datasheet v1.0',
          date: '2025-06-02',
          data: 'Yard Tracking Kit',
        },
      ],

      redDot: 0,
    },

    workerTracking: {
      design: [
        {
          video: 'https://www.youtube.com/embed/l9l7AwAHTok?si=ZXWnI-855hhb7bPu',
          videoEng: 'https://www.youtube.com/embed/gXDb-OgylZw?si=pMbDUgO-FutPZqud',
          title: 'TwinTracker Pro',
          desc: '복잡한 설치 과정 없이 PoE(Power over Ethernet) 연결만으로 자산 태그 단말기의 무선 신호를 추적합니다.',

          img1: twinTracker1,
          img2: twinTracker2,
          img3: twinTracker3,
        },

        {
          title: 'Tag(UWB)',
          desc: '손쉬운 부착으로 작업자의 위치를 추적 할 수 있습니다.',

          img1: '',
          img2: tagUwb1,
          img3: tagUwb2,
        },

        {
          title: 'Server PC',
          desc: '자산의 위치를 저장하고 계산하는 역할을 합니다.',

          img1: serverPc,
          img2: '',
          img3: '',
        },
      ],

      out: [
        {
          title: 'TwinTracker Pro',
          desc: '복잡한 설치 과정 없이 PoE(Power over Ethernet) 연결만으로 자산 태그 단말기의 무선 신호를 추적합니다.',
          img: twinTrackerOutlook,
        },
        {
          title: 'Tag(UWB)',
          desc: '손쉬운 부착으로 작업자의 위치를 추적 할 수 있습니다.',
          img: tagUwbOutlook,
        },
      ],

      thumbnail: workerTracking1,

      //제품 아래 4가지 이미지
      mini1: workerTracking1,
      mini2: tagUwb1,
      mini3: twinTracker1,
      mini4: assetTracking4,

      key1: workerTracking1,
      key2: tagUwb1,
      key3: twinTracker1,

      outlook: [
        {
          title: '',
          desc: '',
          img: twinTrackerOutlook,
        },
      ],

      download: [
        {
          name: 'Server PC - Datasheet v1.0',
          date: '2023-11-20',
          data: 'Server PC',
        },
        {
          name: 'TwinTracker Pro - Datasheet v1.0',
          date: '2023-11-20',
          data: 'TwinTracker Pro',
        },
      ],
      title: 'TwinTracker Pro',
      desc: '복잡한 설치 과정 없이 PoE(Power over Ethernet) 연결만으로 자산 태그 단말기의 무선 신호를 추적합니다.',

      redDot: 0,
    },

    cameraEnterpriseKit: {
      design: [
        {
          video: 'https://www.youtube.com/embed/Z5dC0EKcnuY?si=zeRLmNn-RZXXcjF0',
          videoEng: 'https://www.youtube.com/embed/ZQ8mwjm3lBg?si=Y_89mX4kMcO3wKyl',
          title: 'PTZ Camera',
          desc: 'PTZ 실외 카메라를 통해 주차장의 차량의 위치를 추적합니다.',

          img1: enterpriseKit1,
          img2: '',
          img3: '',
        },

        {
          title: 'NVR',
          desc: '카메라의 이미지 정보를 저장하고 송출 합니다.',

          img1: enterpriseKit2,
          img2: '',
          img3: '',
        },

        {
          title: 'Server PC',
          desc: '이미지를 분석하여 위치를 계산하는 역할을 합니다.',

          img1: enterpriseKit3,
          img2: '',
          img3: '',
        },
      ],

      out: [],

      thumbnail: enterpriseKit1,

      //제품 아래 4가지 이미지
      mini1: enterpriseKit1,
      mini2: enterpriseKit3,
      mini3: enterpriseKit2,
      mini4: '',

      key1: '',
      key2: '',
      key3: '',

      outlook: '',
      topology: enterpriseKitTopology,

      download: [
        {
          name: 'ORBRO AI Server - Datasheet v1.0',
          date: '2025-06-02',
          data: 'ORBRO AI Server',
        },
        {
          name: 'ORBRO Server - Datasheet v1.0',
          date: '2025-06-02',
          data: 'ORBRO Server',
        },
      ],

      title: '',
      desc: '',

      redDot: 0,
    },

    cameraStarterKit: {
      design: [
        {
          title: 'NVR',
          desc: '카메라의 이미지 정보를 저장하고 송출 합니다.',

          img1: starterKit1,
          img2: '',
          img3: '',
        },

        {
          title: 'Server PC',
          desc: '이미지를 분석하여 위치를 계산하는 역할을 합니다.',

          img1: '',
          img2: starterKit2,
          img3: starterKit3,
        },
        {
          title: 'Server PC',
          desc: '이미지를 분석하여 위치를 계산하는 역할을 합니다.',

          img1: '',
          img2: starterKit4,
          img3: starterKit5,
        },
      ],

      out: [],

      thumbnail: starterKit2,

      //제품 아래 4가지 이미지
      mini1: starterKit1,
      mini2: starterKit2,
      mini3: starterKit4,
      mini4: starterKit5,

      key1: '',
      key2: '',
      key3: '',

      outlook: [
        {
          title: 'ORBRO Edge AI',
          desc: 'ONT-EAWF0001',
          img: starterKitOutlook,
        },
        {
          title: 'L2 Switch',
          desc: 'ONT-LRBT5001',
          img: l2SwitchOutlook,
        },
      ],
      topology: starterKitTopology,
      download: [
        {
          name: 'ORBRO Edge AI - Datasheet v1.0',
          date: '2025-06-02',
          data: 'ORBRO Edge AI',
        },
        {
          name: 'L2 Switch - Datasheet v1.0',
          date: '2025-06-02',
          data: 'L2 Switch',
        },
      ],

      title: '',
      desc: '',

      redDot: 0,
    },

    osServer: {
      design: [
        {
          img1: osServer1,
          img2: '',
          img3: '',
          img4: osServer2,
        },
      ],

      out: [],

      thumbnail: osServer1,

      //제품 아래 4가지 이미지
      mini1: osServer1,
      mini2: osServer2,
      mini3: osServer3,

      key1: '',
      key2: '',
      key3: '',

      topology: osServerTopology,

      download: [
        {
          name: 'ORBRO Server - Datasheet v1.0',
          date: '2025-06-02',
          data: 'ORBRO Server',
        },
      ],

      title: '',
      desc: '',

      redDot: 0,
    },

    osRtls: {
      design: [
        {
          img1: edgeRtls1,
          img2: '',
          img3: '',
        },

        {
          img1: '',
          img2: starterKit3,
          img3: starterKit6,
        },
        {
          img1: '',
          img2: starterKit7,
          img3: starterKit8,
        },
      ],

      out: [],

      thumbnail: edgeRtls1,

      //제품 아래 4가지 이미지
      mini1: edgeRtls1,
      mini2: starterKit3,
      mini3: starterKit8,
      mini4: starterKit6,

      key1: '',
      key2: '',
      key3: '',

      topology: osRtlsTopology,

      outlook: [
        {
          title: 'ORBRO Edge RTLS',
          desc: 'ONT-ERWF0001',
          img: edgeRtlsOutlook,
        },
      ],
      download: [
        {
          name: 'ORBRO Edge RTLS - Datasheet v1.0',
          date: '2025-06-02',
          data: 'ORBRO Edge RTLS',
        },
      ],

      title: '',
      desc: '',

      redDot: 0,
    },

    osAi: {
      design: [
        {
          img1: starterKit2,
          img2: '',
          img3: '',
        },

        {
          img1: '',
          img2: starterKit3,
          img3: starterKit6,
        },
        {
          img1: '',
          img2: starterKit7,
          img3: osEdgeAiBottom,
        },
      ],

      out: [],

      thumbnail: starterKit2,

      //제품 아래 4가지 이미지
      mini1: edgeAi1,
      mini2: starterKit3,
      mini3: osEdgeAiBottom,
      mini4: starterKit6,

      key1: '',
      key2: '',
      key3: '',

      topology: osAiTopology,

      outlook: [
        {
          title: 'ORBRO Edge AI',
          desc: 'ONT-EAWF0001',
          img: starterKitOutlook,
        },
      ],
      download: [
        {
          name: 'ORBRO Edge AI - Datasheet v1.0',
          date: '2025-06-02',
          data: 'ORBRO Edge AI',
        },
      ],

      title: '',
      desc: '',

      redDot: 0,
    },

    osSwitch: {
      design: [
        {
          img1: starterKit4,
          img2: '',
          img3: '',
        },

        {
          img1: '',
          img2: starterKit5,
          img3: starterKit9,
        },
        {
          img1: '',
          img2: starterKit7,
          img3: osL2SwitchBottom,
        },
      ],

      out: [],

      thumbnail: starterKit4,

      //제품 아래 4가지 이미지
      mini1: starterKit4,
      mini2: starterKit5,
      mini3: osL2SwitchBottom,
      mini4: starterKit9,

      key1: '',
      key2: '',
      key3: '',

      topology: osSwitchTopology,

      outlook: [
        {
          title: 'L2 Switch',
          desc: 'ONT-LRBT5001',
          img: l2SwitchOutlook,
        },
      ],
      download: [
        {
          name: 'L2 Switch - Datasheet v1.0',
          date: '2025-06-02',
          data: 'L2 Switch',
        },
      ],

      title: '',
      desc: '',

      redDot: 0,
    },

    ptz: {
      design: [
        {
          title: 'PTZ Camera',
          desc: 'PTZ 실외 카메라를 통해 주차장의 차량의 위치를 추적합니다.',

          img1: ptzCamKey1,
          img2: ptzCamKey2,
          img3: ptzCamKey3,
        },
      ],

      out: [],

      thumbnail: ptzThumb,

      //제품 아래 4가지 이미지
      mini1: ptzCam1,
      mini2: ptzCam2,
      mini3: ptzCam3,
      mini4: ptzCam4,

      key1: '',
      key2: '',
      key3: '',

      outlook: '',
      download: [
        {
          name: 'PTZ Camera - Datasheet v1.0',
          date: '2023-11-20',
          data: 'PTZ Camera',
        },
      ],

      title: '',
      desc: '',

      redDot: 0,
    },

    ip: {
      design: [
        {
          title: 'IP Camera',
          desc: 'IP 카메라를 통해 실내 유동 인구를 추적합니다.',

          img1: ipCamKey1,
          img2: ipCamKey2,
          img3: ipCamKey3,
        },
      ],

      out: [],

      thumbnail: ipThumb,

      //제품 아래 4가지 이미지
      mini1: ipCam1,
      mini2: ipCam2,
      mini3: ipCam3,
      mini4: ipCam4,

      key1: '',
      key2: '',
      key3: '',

      outlook: '',
      download: [
        {
          name: 'IP Camera - Datasheet v1.0',
          date: '2023-11-20',
          data: 'IP Camera',
        },
      ],

      title: '',
      desc: '',

      redDot: 0,
    },

    safetyBell: {
      thumbnail: safetyBellThumbnail,

      mini1: bell1,
      mini2: bell2,
      mini3: bell3,
      mini4: bell4,

      key1: bell1,
      key2: bell2,
      key3: bell3,

      outlook: [
        {
          title: '',
          desc: '',
          img: bellOutlook,
        },
      ],
      download: [
        {
          name: 'Safety Bell - Datasheet v1.0',
          date: '2025-06-02',
          data: 'Safety Bell',
        },
      ],

      redDot: 0,
    },

    smartSwitch: {
      thumbnail: switchThumbnail,

      mini1: switch1,
      mini2: switch2,
      mini3: switch3,
      mini4: switch4,

      key1: switch1,
      key2: switch2,
      key3: switch3,

      outlook: [
        {
          title: '',
          desc: '',
          img: switchOutlook,
        },
      ],
      download: [
        {
          name: 'Smart Switch - Datasheet v1.0',
          date: '2023-11-20',
          data: 'Smart Switch',
        },
      ],

      redDot: 0,
    },

    esl: {
      thumbnail: eslThumbnail,

      mini1: esl1,
      mini2: esl2,
      mini3: esl3,
      mini4: esl4,

      key1: esl1,
      key2: esl2,
      key3: esl3,

      outlook: [
        {
          title: '',
          desc: '',
          img: eslOutlook,
        },
      ],
      download: [
        {
          name: 'E-ink Display - Datasheet v1.0',
          date: '2023-11-20',
          data: 'E-ink Display',
        },
      ],

      redDot: 0,
    },

    mTag: [
      {
        thumbnail: mTagThumb,

        mini1: mTag1,
        mini2: mTag2,
        mini3: mTag3,
        mini4: mTag4,

        key1: mTag1,
        key2: mTag2,
        key3: mTag3,

        outlook: [
          {
            title: '',
            desc: '',
            img: mTagOutlook,
          },
        ],
        redDot: 1,
      },

      {
        thumbnail: mTag2_Thumb,

        mini1: mTag2_1,
        mini2: mTag2_2,
        mini3: mTag2_3,
        mini4: mTag2_4,

        key1: mTag2_key1,
        key2: mTag2_key2,
        key3: mTag2_key3,

        outlook: [
          {
            title: '',
            desc: '',
            img: mTag2_Outlook,
          },
        ],
        redDot: 1,
      },
    ],

    mCradle: {
      thumbnail: mCradleThumb,

      mini1: mCradle1,
      mini2: mCradle2,
      mini3: mCradle3,
      mini4: mCradle4,

      key1: mCradle5,
      key2: mCradle6,
      key3: mCradle7,

      outlook: [
        {
          title: '',
          desc: '',
          img: mCradleOutlook,
        },
      ],

      redDot: 0,
    },

    idCard: {
      thumbnail: idCard1,

      mini1: idCard1,
      mini2: idCard2,
      mini3: idCard3,
      mini4: idCard4,

      key1: idCard5,
      key2: idCard6,
      key3: idCard7,

      outlook: [
        {
          title: '',
          desc: '',
          img: idCardOutlook,
        },
      ],

      redDot: 0,
    },

    loraGateway: {
      thumbnail: loraGateway1,

      mini1: loraGateway1,
      mini2: loraGateway2,
      mini3: loraGateway3,
      mini4: loraGateway4,

      key1: loraGateway1,
      key2: loraGateway2,
      key3: loraGateway3,

      outlook: '',

      download: [
        {
          name: 'LoRa Gateway - Datasheet v1.0',
          date: '2025-06-02',
          data: 'LoRa Gateway',
        },
      ],
      redDot: 0,
    },

    loraSensor: {
      thumbnail: loraSensor1,

      mini1: loraSensor1,
      mini2: loraSensor2,
      mini3: loraSensor3,
      mini4: loraSensor4,

      key1: loraSensor1,
      key2: loraSensor2,
      key3: loraSensor3,

      outlook: '',

      download: [
        {
          name: 'LoRa Sensor - Datasheet v1.0',
          date: '2025-06-02',
          data: 'LoRa Sensor',
        },
      ],
      redDot: 0,
    },

    airQuality: {
      thumbnail: airQuality1,

      mini1: airQuality1,
      mini2: airQuality2,
      mini3: airQuality3,
      mini4: airQuality4,

      key1: airQuality1,
      key2: airQuality2,
      key3: airQuality3,

      outlook: '',

      download: [
        {
          name: 'VENTAX - Datasheet v1.0',
          date: '2025-06-02',
          data: 'VENTAX',
        },
      ],

      redDot: 0,
    },

    coMeasure: {
      thumbnail: coMeasure1,

      mini1: coMeasure1,
      mini2: coMeasure2,
      mini3: coMeasure3,
      mini4: coMeasure4,

      key1: coMeasure1,
      key2: coMeasure2,
      key3: coMeasure3,

      outlook: '',

      download: [
        {
          name: 'CO2 - Datasheet v1.0',
          date: '2025-06-02',
          data: 'CO2',
        },
      ],
      redDot: 0,
    },

    plutoconPro: {
      thumbnail: accesscontrollerThumb,

      mini1: accesscontroller1,
      mini2: accesscontroller2,
      mini3: accesscontroller3,
      mini4: accesscontroller4,

      key1: accesscontroller1,
      key2: accesscontroller2,
      key3: accesscontroller3,

      outlook: [
        {
          title: '',
          desc: '',
          img: accesscontrollerOutlook,
        },
      ],
      download: [
        {
          name: 'Plutocon Pro - Datasheet v1.0',
          date: '2023-11-20',
          data: 'Plutocon Pro',
        },
      ],

      redDot: 0,
    },

    orbroTag: {
      thumbnail: orbroTag1,

      mini1: orbroTag1,
      mini2: orbroTag2,
      mini3: orbroTag3,
      mini4: orbroTag4,

      key1: orbroTag1,
      key2: orbroTag2,
      key3: orbroTag3,

      outlook: [
        {
          title: '',
          desc: '',
          img: orbroTagOutlook,
        },
      ],
      download: [
        {
          name: 'ORBRO Tag - Datasheet v1.0',
          date: '2023-11-20',
          data: 'ORBRO Tag',
        },
      ],

      redDot: 0,
    },

    assetTag: {
      thumbnail: assetTag1,

      mini1: assetTag1,
      mini2: assetTag2,
      mini3: assetTag3,
      mini4: assetTag4,

      key1: assetTag1,
      key2: assetTag4,
      key3: assetTag3,

      outlook: [
        {
          title: '',
          desc: '',
          img: assetTagOutlook,
        },
      ],

      redDot: 0,
    },

    //
    robotBasic: {
      design: [
        {
          title: 'Delivery Robot',
          desc: '오브로 시스템 연동을 통해 물건을 배송하는 역할을 합니다.',

          img2: deliverRobot1,
          img3: deliverRobot2,
        },

        {
          title: 'Twin Tracker Pro',
          desc: '복작한 설치 과정 없이 PoE(Power over Ethernet) 연결만으로 태그 단말기의 무선 신호를 추적합니다.',

          img1: twinTracker1,
          img2: twinTracker2,
          img3: twinTracker3,
        },

        {
          title: 'Tag(UWB)',
          desc: '손쉬운 부착으로 작업자의 위치를 추적 할 수 있습니다.',

          img2: tagUwb1,
          img3: tagUwb2,
        },

        {
          title: 'Server PC',
          desc: '자산의 위치를 저장하고 계산하는 역할을 합니다.',
          img1: serverPc,
          img2: '',
          img3: '',
        },
      ],

      out: [],

      thumbnail: deliverRobot1,

      //제품 아래 4가지 이미지
      mini1: deliverRobot1,
      mini2: tagUwb1,
      mini3: twinTracker1,
      mini4: assetTracking4,

      key1: '',
      key2: '',
      key3: '',

      outlook: '',

      title: '',
      desc: '',

      redDot: 0,
    },

    delivery: {
      design: [
        {
          title: 'Delivery Robot',
          desc: '오브로 시스템 연동을 통해 물건을 배송하는 역할을 합니다.',

          img2: deliverRobot1,
          img3: deliverRobot2,
        },

        {
          title: 'Loading Kiosk',
          desc: '장치 위에 배송할 물품을 올려두고 로봇을 호출하면 자동으로 물품을 상차하는 역할을 담당합니다.',

          img2: loadingKiosk1,
          img3: loadingKiosk2,
        },

        {
          title: 'Cobot',
          desc: '배송로봇 도착시 배송 로봇에 있는 물건을 하차하는 역할을 담당합니다.',

          img2: cobot3,
          img3: cobot2,
        },

        {
          title: 'Twin Tracker Pro',
          desc: '복작한 설치 과정 없이 PoE(Power over Ethernet) 연결만으로 태그 단말기의 무선 신호를 추적합니다.',

          img1: twinTracker1,
          img2: twinTracker2,
          img3: twinTracker3,
        },

        {
          title: 'Tag(UWB)',
          desc: '손쉬운 부착으로 작업자의 위치를 추적 할 수 있습니다.',

          img2: tagUwb1,
          img3: tagUwb2,
        },

        {
          title: 'Server PC',
          desc: '자산의 위치를 저장하고 계산하는 역할을 합니다.',
          img1: serverPc,
          img2: '',
          img3: '',
        },
      ],

      out: [],

      thumbnail: deliverPackage,

      //제품 아래 4가지 이미지
      mini1: deliverPackage,
      mini2: loadingKiosk2,
      mini3: cobot1,
      mini4: workerTracking1,

      key1: '',
      key2: '',
      key3: '',

      outlook: '',

      title: '',
      desc: '',

      redDot: 0,
    },

    disinfection: {
      design: [
        {
          title: 'Delivery Robot',
          desc: '오브로 시스템 연동을 통해 물건을 배송하는 역할을 합니다.',

          img2: deliverRobot1,
          img3: deliverRobot2,
        },

        {
          title: 'Loading Kiosk',
          desc: '장치 위에 배송할 물품을 올려두고 로봇을 호출하면 자동으로 물품을 상차하는 역할을 담당합니다.',

          img2: loadingKiosk1,
          img3: loadingKiosk2,
        },

        {
          title: 'Cobot',
          desc: '배송로봇 도착시 배송 로봇에 있는 물건을 하차하는 역할을 담당합니다.',

          img2: cobot3,
          img3: cobot2,
        },

        {
          title: 'Disinfection Device Kit',
          desc: '배송로봇 상하차 프로세스에서 안전하게 소독 역할을 담당하는 제품입니다.',
          img1: disinfection2,
        },

        {
          title: 'Twin Tracker Pro',
          desc: '복작한 설치 과정 없이 PoE(Power over Ethernet) 연결만으로 태그 단말기의 무선 신호를 추적합니다.',

          img1: twinTracker1,
          img2: twinTracker2,
          img3: twinTracker3,
        },

        {
          title: 'Tag(UWB)',
          desc: '손쉬운 부착으로 작업자의 위치를 추적 할 수 있습니다.',

          img2: tagUwb1,
          img3: tagUwb2,
        },

        {
          title: 'Server PC',
          desc: '자산의 위치를 저장하고 계산하는 역할을 합니다.',
          img1: serverPc,
          img2: '',
          img3: '',
        },
      ],

      out: [],

      thumbnail: disinfection1,

      //제품 아래 4가지 이미지
      mini1: disinfection1,
      mini2: loadingKiosk2,
      mini3: cobot1,
      mini4: disinfection2,

      key1: '',
      key2: '',
      key3: '',

      outlook: '',

      title: '',
      desc: '',

      redDot: 0,
    },
  },
};
